/**
 * TODO Later - Refactor to js ns
 *  Enables the display of loading animation on certain element by swapping it for a "loading" element of the same size.
 */
LoadingAnimator = {
    BACKDROP_ID: 'loading-backdrop',
    LOADING_VIA_REPLACE_DATA: 'data-loading-via-replace-animation-id',
    LOADING_OVERLAY_DATA: 'data-loading-overlay-animation-id',

    /**
     * The class added via server-side code to the container over which loading animation is displayed when used right
     * after the page load.
     */
    ON_PAGE_DISPLAYED_CONTAINER_CLASS: 'being-loaded',
    ON_PAGE_DISPLAYED_LOADER_CLASS: 'loading-spinner',

    /**
     * The default delay when hiding backdrop (to allow all loadings underneath it to finish).
     */
    DEFAULT_BACKDROP_HIDING_DELAY: 200,

    backdropDisplayed: false,

    /*
    |-------------------------------------------------------------------------------------------------------------------
    | Loading
    |-------------------------------------------------------------------------------------------------------------------
    */

    /**
     * Displays a fullscreen loading animation.
     */
    showLoadingBackdrop: function () {
        if (this.backdropDisplayed === false) {
            $('body').append($(this.private.createBackdrop(this.BACKDROP_ID)));

            this.backdropDisplayed = true;
        }
    },

    hideLoadingBackdrop: function () {
        $('#' + this.BACKDROP_ID).remove();

        this.backdropDisplayed = false;
    },

    showLoadingOverlay: function ($element) {
        const loaderId = this.getLoaderId($element, this.LOADING_OVERLAY_DATA, 'overlay');
        const $loader = $('#' + loaderId);

        if ($loader.length) {
            // We already have the loader, it is just hidden
            $loader.show();
        } else {
            // We need to create a new loader
            const $loaderHtml = $(this.private.createOverlay(loaderId));

            $loaderHtml.outerHeight($element.outerHeight());

            $element.prepend($loaderHtml);
        }
    },

    hideLoadingOverlay: function ($element) {
        const loaderId = this.getLoaderId($element, this.LOADING_OVERLAY_DATA, 'overlay');
        $('#' + loaderId).hide();
    },

    /**
     * Replaces the element with loading animation.
     *
     * @param $element
     */
    showLoadingViaReplace: function ($element) {
        const loaderId = this.getLoaderId($element, this.LOADING_VIA_REPLACE_DATA, 'via-replace');
        const $loader = $("#" + loaderId);

        if ($loader.length) {
            // We already have the loader, it is just hidden
            $element.hide();
            $loader.show();
        } else {
            // We need to create a new loader
            const loaderHtml = this.private.createLoaderHtml(loaderId, 'via-replace');

            ElementSoftSwapper.swapForNew($element, loaderHtml);
        }
    },

    /**
     * Displays the original element and hides the loading animation.
     *
     * @param $element
     */
    hideLoadingViaReplace: function ($element) {
        const loaderId = this.getLoaderId($element, this.LOADING_VIA_REPLACE_DATA, 'via-replace');
        $('#' + loaderId).hide();

        $element.show();
    },

    /*
    |-------------------------------------------------------------------------------------------------------------------
    | HTML loaders
    |-------------------------------------------------------------------------------------------------------------------
    | Handling of loaders that are already displayed on page load (as opposed to other loaders that are dynamically
    | added via Javascript).
    */

    /**
     * Hides the server-side generated loading animation.
     *
     * @param $container
     */
    hideOnPageDisplayedLoading: function ($container) {
        $container.removeClass(this.ON_PAGE_DISPLAYED_CONTAINER_CLASS);

        const $loader = $($container.find('.' + this.ON_PAGE_DISPLAYED_LOADER_CLASS).get(0));
        $loader.remove();
    },

    /*
    |-------------------------------------------------------------------------------------------------------------------
    | Loading-triggering elements helpers
    |-------------------------------------------------------------------------------------------------------------------
    */

    /**
     * Provides an instance that will handle the animation of loading triggered by given element.
     *
     * @param $element
     * @param {Object} type The type. See {@link Lfl.AsynchronousLoading.ElementLoadingAnimationHandler} for more info.
     * @returns {Lfl.AsynchronousLoading.ElementLoadingAnimationHandler}
     */
    getAnimationHandlerFor: function ($element, type) {
        return new Lfl.AsynchronousLoading.ElementLoadingAnimationHandler($element, type);
    },

    /*
    |-------------------------------------------------------------------------------------------------------------------
    | Ids generation
    |-------------------------------------------------------------------------------------------------------------------
    */

    /**
     * @param $element
     * @param dataName The data attribute name used when storing this id on the element (e.g. loader-id).
     * @param loadingType
     *
     * @returns {*}
     */
    getLoaderId: function ($element, dataName, loadingType) {
        if ($element.attr(dataName)) {
            return $element.attr(dataName);
        }

        let idBase;

        if (!$element.attr('id')) {
            idBase = FullDomPathProvider.getSanitizedDomPath($element);
        } else {
            idBase = $element.attr('id');
        }

        const loaderId = idBase + '-' + loadingType + '-loader';

        $element.attr(dataName, loaderId);

        return loaderId;
    },

    /*
    |-------------------------------------------------------------------------------------------------------------------
    | Private
    |-------------------------------------------------------------------------------------------------------------------
    */

    /**
     * TODO Later - Not truly private. Should refactor to jsnsns and separate these methods from public API.
     */
    private: {
        createBackdrop: function (id) {
            return '<div id="' + id + '" class="loading-backdrop">'
                    + '<div class="loading-background"></div>'
                    + this.createLoaderHtml('')
                + "</div>";
        },

        createOverlay: function (id) {
            return '<div id="' + id + '" class="element-loading-overlay">'
                    + '<div class="loading-background"></div>'
                    + this.createLoaderHtml('')
                + "</div>";
        },

        createLoaderHtml: function (loaderId, additionalClass) {
            if (typeof additionalClass === 'undefined') {
                additionalClass = '';
            }

            return "<div id=\"" + loaderId + "\" class=\"loading-spinner" + additionalClass + "\">"
                    + "<div class=\"loading-ball\"></div>"
                + "</div>";
        }
    },
};
